<template>
  <el-dialog
    class="btn-close"
    :append-modelody="true"
    :modal-append-to-body="false"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :before-close="handleClose"
  >
    <div class="dialog-box">
      <div class="btns-info">
        <!-- <a
          class="btn-text"
          @click="setTab(1)"
          style="margin-right: 10px"
          :class="{ active: role == 1 }"
          ><i class="iconfont iconicon-"></i> 手机面试</a
        > -->
        <a
          class="btn-text"
          @click="setTab(2)"
          style="margin-left: 10px"
          :class="{ active: role == 2 }"
          ><i class="iconfont icondiannao1"></i> 电脑面试</a
        >
      </div>
      <div class="inner">
        <div class="forMobile" v-if="role == 1">
          <div class="list">
            <div class="title">面试官入口</div>
            <div class="img">
              <img :src="demoDetail.tu2 || ''" />
            </div>
          </div>
          <div class="list">
            <div class="title">候选人入口</div>
            <div class="img">
              <img :src="demoDetail.tu1 || ''" />
            </div>
          </div>
          <!-- <div class="list">
            <div class="title">电脑PC - 面试体验</div>
            <div class="img">
              <img :src="demoDetail.tu1" />
            </div>
          </div> -->
        </div>
        <div class="forPc" v-if="role == 2">
          面试官链接：<a
            class="blue"
            :href="demoDetail.link2"
            target="_blank"
            >{{ demoDetail.link2 }}</a
          >
          <i class="iconfont iconlianjie" @click="copy(demoDetail.link2)"></i
          ><br />
          候选人链接：<a
            class="blue"
            :href="demoDetail.link1"
            target="_blank"
            >{{ demoDetail.link1 }}</a
          >
          <i class="iconfont iconlianjie" @click="copy(demoDetail.link1)"></i>
        </div>
      </div>
      <div class="info">
        <div>说明：面试体验时长<span>10分钟</span>，</div>
        请用两个电脑的chrome浏览器分别打开链接体验。
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['dialogVisible', 'demoDetail', 'dialogWidth'],
  data() {
    return {
      role: 2,
    }
  },
  methods: {
    copy(url) {
      var oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      this.$message.success('复制成功！')
    },
    setTab(num) {
      this.role = num
    },
    handleClose(done) {
      this.$emit('onCancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-box {
  padding: 20px 30px;
  font-weight: 300;
  .btns-info {
    text-align: center;
    .btn-text {
      padding: 6px 15px;
      border: 2px solid #c2c2c2;
      border-radius: 4px;
      color: #999;
      cursor: pointer;
      font-size: 18px;
      background-color: #fff;
      .iconfont {
        font-size: 20px;
      }
      &.active {
        color: #29bdb9;
        border: 2px solid #29bdb9;
      }
    }
  }
  .inner {
    border: 1px solid #e7e7e7;
    background-color: #fbfbfb;
    min-height: 80px;
    margin-top: -12px;
    .forPc {
      text-align: center;
      padding: 60px 0px;
      font-size: 16px;
      line-height: 40px;
      a {
        color: #29bdb9;
        text-decoration: none;
      }
      .iconlianjie {
        color: #999;
        margin-left: 10px;
        cursor: pointer;
      }
      i {
        font-size: 14px;
      }
    }
    .forMobile {
      display: flex;
      padding: 30px 0px;
      text-align: center;
      .list {
        width: 50%;
        margin-top: 20px;
        padding: 0px 0px 0px;
        .title {
          font-size: 18px;
          padding: 0px 0px 12px;
        }
        .img {
          img {
            width: 150px;
          }
        }
        &:first-child {
          border-right: 1px solid #eee;
        }
      }
    }
  }
  .info {
    text-align: center;
    color: #999;
    padding-top: 10px;
    line-height: 30px;
    span {
      color: #29bdb9;
    }
  }
}
@media screen and (max-width: 600px) {
  .dialog-box {
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/test.vue